import { render, staticRenderFns } from "./UGCArtworkContestReport.vue?vue&type=template&id=55ce2a25"
import script from "./UGCArtworkContestReport.vue?vue&type=script&lang=js"
export * from "./UGCArtworkContestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports